import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Trash2, Download } from "lucide-react";
import { toast } from "sonner";

export default function AdminSignups() {
  const [list, setList] = useState([]);
  const load = () => http.get("/admin/signups").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this signup?")) return;
    await http.delete(`/admin/signups/${id}`);
    load();
  };

  const exportCsv = () => {
    const header = "email,source,created_at\n";
    const rows = list.map((s) => `${s.email},${s.source || ""},${s.created_at}`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "blesco_signups.csv"; a.click();
    toast.success("Exported");
  };

  return (
    <div>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold">Email Signups</h1>
          <p className="text-white/45 text-sm mt-1">{list.length} subscribers</p>
        </div>
        <button onClick={exportCsv} className="bls-admin-btn-ghost" data-testid="admin-signups-export">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      <div className="mt-8 bls-admin-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr>
              <th className="bls-admin-th">Email</th>
              <th className="bls-admin-th">Source</th>
              <th className="bls-admin-th">Joined</th>
              <th className="bls-admin-th text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={4} className="bls-admin-td text-center text-white/45">No signups yet</td></tr>}
            {list.map((s) => (
              <tr key={s.id} className="bls-admin-tr">
                <td className="bls-admin-td">{s.email}</td>
                <td className="bls-admin-td text-white/55 text-xs">{s.source}</td>
                <td className="bls-admin-td text-white/55 text-xs">{new Date(s.created_at).toLocaleString()}</td>
                <td className="bls-admin-td text-right">
                  <button onClick={() => remove(s.id)} className="bls-admin-btn-ghost"><Trash2 className="w-3 h-3" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
